import React, { Fragment } from 'react'
import { number, object, string } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { resultsPageMessages as messages } from './messages'
import { TOPIC } from '../filters/constants'

const ResultCount = ({ totalResults, query, filters }) => {
  const activeFilters = Object.keys(filters).map(key => {
    if (key === TOPIC) return null
    return <Fragment key={`result-count-${key}`}> | <span>{decodeURIComponent(filters[key])}</span></Fragment>
  })

  return (
    <p className='search-header__row search-header__result-count'>
      <span>
        <FormattedMessage values={{ count: totalResults }}
          {...(totalResults === 1 ? messages.resultCountOne : messages.resultCountMany)}
        />
      </span>
      {query && <> | <em>&quot;{query}&quot;</em> </>}
      {activeFilters}
    </p>
  )
}

ResultCount.propTypes = {
  totalResults: number.isRequired,
  query: string,
  filters: object
}

export default ResultCount
